import { RouteLoadingShell } from "@/components/portal/route-loading-shell";

export default function AdminAgentSettingsLoading() {
  return <RouteLoadingShell variant="admin-table" />;
}
